import { useState } from 'react';
import * as Slider from '@radix-ui/react-slider';
import { clsx } from 'clsx';

const energyLevels = [
  { min: 0, max: 20, label: 'Depleted', class: 'energy-depleted' },
  { min: 21, max: 40, label: 'Low', class: 'energy-low' },
  { min: 41, max: 60, label: 'Moderate', class: 'energy-moderate' },
  { min: 61, max: 80, label: 'Good', class: 'energy-good' },
  { min: 81, max: 100, label: 'Peak', class: 'energy-peak' },
];

function getEnergyLevel(value: number) {
  return energyLevels.find((l) => value >= l.min && value <= l.max) || energyLevels[2];
}

export function EnergySlider() {
  const [energy, setEnergy] = useState(50);
  const [hasInteracted, setHasInteracted] = useState(false);
  const level = getEnergyLevel(energy);

  const handleChange = (values: number[]) => {
    setEnergy(values[0]);
    setHasInteracted(true);
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <label className="text-sm font-medium">How's your energy?</label>
        <span className={clsx('text-sm font-medium', level.class)}>
          {level.label}
        </span>
      </div>

      <Slider.Root
        className="relative flex items-center select-none touch-none w-full h-10"
        value={[energy]}
        onValueChange={handleChange}
        max={100}
        step={5}
      >
        <Slider.Track className="bg-white/10 relative grow rounded-full h-3">
          <Slider.Range
            className={clsx(
              'absolute h-full rounded-full transition-colors duration-300',
              energy <= 20 && 'bg-accent-danger',
              energy > 20 && energy <= 40 && 'bg-accent-warning',
              energy > 40 && energy <= 60 && 'bg-white/40',
              energy > 60 && energy <= 80 && 'bg-accent-success',
              energy > 80 && 'bg-accent-secondary'
            )}
          />
        </Slider.Track>
        <Slider.Thumb
          className={clsx(
            'block w-8 h-8 bg-white rounded-full shadow-lg',
            'focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-secondary',
            'transition-transform duration-200 hover:scale-110'
          )}
        />
      </Slider.Root>

      {!hasInteracted && (
        <p className="text-xs text-white/40 text-center">
          Slide to check in (optional)
        </p>
      )}
    </div>
  );
}
